module.exports = __webpack_public_path__ + "img/route-no-schedule.4ca85606.png";